import type { MetaData } from './CaseStudy.types';
export const metaData = (title: string, content: string): MetaData => ({
  title,
  meta: [
    {
      name: 'description',
      content,
    },
  ],
});
